// @flow
import React, { Component } from 'react';
import type { Node } from 'react';
import onClickOutside from 'react-onclickoutside';
import styled from 'styled-components';
import { colors } from 'bench-style-constants';

const SidebarElement = styled.div`
  background-color: ${colors.white};
  max-height: 100%;
  overflow-y: hidden;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
  ${({ show, position }) =>
    show
      ? `
      grid-column: ${position === 'right' ? '3' : '1'} / span 1;
      grid-row: 1;
      z-index: 20;
    `
      : `display: none;`};
`;

type SidebarProps = {
  show: boolean,
  position: 'right' | 'left',
  onClickOutside?: () => void, // eslint-disable-line react/require-default-props
  children: Node,
};

class Sidebar extends Component<SidebarProps> {
  handleClickOutside = () => {
    if (this.props.onClickOutside) {
      this.props.onClickOutside();
    }
  };

  render() {
    const { show, position, children } = this.props;

    return (
      <SidebarElement show={show} position={position}>
        {children}
      </SidebarElement>
    );
  }
}

export default onClickOutside(Sidebar);
